export interface PreviewIntentStore {
  getActiveId(): string | null;
  setActiveId: (id: string | null) => void;
  subscribe: (listener: () => void) => () => void;
  registerStopHandler: (id: string, handler: () => void) => () => void;
}

export function createPreviewIntentStore(
  initialActiveId: string | null = null
): PreviewIntentStore {
  let activeId: string | null = initialActiveId;
  const listeners = new Set<() => void>();
  const stopHandlers = new Map<string, () => void>();

  const emit = () => {
    for (const listener of listeners) {
      listener();
    }
  };

  return {
    getActiveId() {
      return activeId;
    },
    setActiveId(id) {
      if (activeId === id) return;

      const prev = activeId;
      if (prev) {
        const stop = stopHandlers.get(prev);
        stop?.();
      }
      activeId = id;
      emit();
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    registerStopHandler(id, handler) {
      stopHandlers.set(id, handler);
      return () => {
        const existing = stopHandlers.get(id);
        if (existing === handler) {
          stopHandlers.delete(id);
        }
      };
    },
  };
}
